/* eslint-disable max-lines */
/* eslint-disable quote-props */
import { i18n } from '@/setup/i18n';

export const AUTH_STATUS = {
  loading: 'loading',
  success: 'success',
  error: 'error'
};

export const STATUS_VARIATIONS = {
  RISK_STATUS: {
    NUEVO: 'primary',
    AUTORIZADO: 'success',
    EN_ESTUDIO: 'info',
    DENEGADO: 'danger',
    FALTA_DOCUMENTACION: 'warning',
    IBAN_DUPLICADO: 'warning',
    CANCELADA: 'secondary',
    NO_INTERESADO: 'light'
  },
  SIGN_STATUS: {
    SIN_IMPRIMIR: 'secondary',
    CONTRATO_IMPRESO: 'warning',
    CONTRATO_FIRMADO: 'success'
  },
  OPERATION_STATUS: {
    NUEVA: 'primary',
    EN_CURSO: 'success',
    CANCELADA: 'dark',
    FALTA_DOCUMENTACION: 'warning',
    NO_INTERESADO: 'light'
  }
};

export const GLOBAL_STATUS = {
  NEW: 'NUEVO',
  TO_SIGNED: 'ENVIADO_A_FIRMA',
  TO_SIGNED_MANUAL: 'ENVIADO_A_FIRMA_MANUAL',
  IN_STUDY: 'EN_ESTUDIO',
  AUTHORIZED: 'AUTORIZADO',
  DENIED: 'DENEGADO',
  CANCELED: 'CANCELADA',
  NOT_INTERESED: 'NO_INTERESADO',
  UPLOADED_DOCUMENTATION: 'DOCUMENTACION_SUBIDA',
  MISSING_DOCUMENTATION: 'FALTA_DOCUMENTACION',
  MISSING_JUSTIFYING: 'FALTA_JUSTIFICANTE'
};

export const DATA_OPERATION = {
  CONTACT_TYPE: {
    ATTORNEY: 'APODERADO',
    CONTACT: 'CONTACTO'
  },
  CUSTOMER_TYPE: {
    PARTICULAR: 'PFISICA',
    COMPANY: 'PJURIDICA'
  },
  FLUX: {
    STRATOS: 'STRATOS',
    TESLA: 'TESLA'
  }
};

export const FLOWS_PARTNER_REDIRECT_CONTRACT = {
  B2C: { routerName: 'new-request' },
  B2B: { routerName: 'new-request-b2b' }
};

export const DOCUMENT_TYPES = {
  DNI: 1,
  NIE: 2
};

export const DOCUMENT_TYPES_DESCRIPTION = {
  1: 'DNI',
  2: 'NIF',
  3: 'CIF',
  4: 'Pasaporte',
  5: 'NIE',
  6: 'PasDiplomático',
  7: 'PersonasFisicas',
  8: 'PersonasJuridicas'
};

export const APP_ROLES = {
  ALD_ADMIN: 'ALDAdmin',
  ALD_USER: 'ALDUser',
  ALD_DEVELOPER: 'ALDDeveloper',
  PARTNER_ADMIN: 'PartnerAdmin',
  PARTNER_USER: 'PartnerUser'
};

export const OPERATION_STATUS = {
  OK: 200,
  KO: 99
};

/** FILTROS ---------------------------- */

export const TYPE_VEHICLE_FILTER_OPTIONS = [
  {
    value: 'TODOS',
    label: 'TODOS'
  },
  {
    value: 'NUEVO',
    label: 'NUEVO'
  },
  {
    value: 'USADO&format[eqs]=collapse',
    label: 'USADO'
  },
  /* {
     value: 'VENTA',
     label: 'VENTA'
   } */
];
export const TYPE_FLOW_FILTER_OPTIONS = [
  {
    value: 'TODOS',
    label: 'TODOS'
  },
  {
    value: 'b2c',
    label: 'B2C'
  },
  {
    value: 'b2b',
    label: 'B2B'
  }
];
export const KILOMETERS_FILTER_OPTIONS = [
  {
    value: '10000',
    label: '10.000 KM'
  },
  {
    value: '20000',
    label: '20.000 KM'
  },
  {
    value: '30000',
    label: '30.000 KM'
  }
];

export const MODALITY_FILTER_OPTIONS = [
  {
    value: 'TODOS',
    label: 'TODOS'
  },
  {
    value: 'ALQUILER',
    label: 'REDRIVE'
  },
  {
    value: 'ALQUILER.VENTA',
    label: 'REDRIVE+VENTA'
  },
  {
    value: 'VENTA',
    label: 'VENTA'
  }
];

export const TERM_FILTER_OPTIONS = [
  {
    value: '12',
    label: '12'
  },
  {
    value: '24',
    label: '24'
  },
  {
    value: '36',
    label: '36'
  },
  {
    value: '48',
    label: '48'
  }
];

export const RANGE_PRICE_OPTIONS = [0, 3000];

export const DATA_SLIDER = [300, 400, 500, 600, 700, 800, 900];

export const TYPE_FUEL_FILTER_OPTIONS = [
  {
    value: 'diesel',
    label: 'DIÉSEL'
  },
  {
    value: 'gasolina',
    label: 'GASOLINA'
  },
  {
    value: 'hibrido',
    label: 'HÝBRIDO'
  },
  {
    value: 'electrico',
    label: 'ELÉCTRICO'
  },
  {
    value: 'glp',
    label: 'GLP'
  }
];

export const CAMPAIGN_FACTORY = [
  {
    label: 'Pedido a fábrica',
    value: 'true'
  },
  {
    label: 'Campaña',
    value: 'false'
  }
];

export const PUBLICATION_TYPE = {
  SINGLE: 'SINGLE',
  FAMILY: 'FAMILY'
};

export const RANGE_EMISSIONS_OPTIONS = [0, 250];

export const DATA_EMISSIONS_SLIDER = ['<0', '50', '100', '150', '200', '>250'];

export const FILTERS_BY_DEFAULT = {
  showRoom: {
    filtersHasChanged: false,
    filtersHasReseted: true,
    filters: {
      campaignType: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'campaignType[eqs]=#values#'
      },
      modality: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'modality[eqs]=#values#'
      },
      flow: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'flow[eqs]=#values#'
      },
      carFuelType: {
        value: [],
        dataType: 'Array',
        query: 'car.fuelType[in]=#values#'
      },
      carPlateNumber: {
        value: '',
        dataType: 'String',
        query: 'car.plateNumber[like]=#value#'
      },
      carBrand: {
        value: '',
        dataType: 'String',
        query: 'car.brand[eqs]=#value#'
      },
      carModel: {
        value: '',
        dataType: 'String',
        query: 'car.model[eqs]=#value#'
      },
      carBodyStyle: {
        value: [],
        dataType: 'Array',
        query: 'car.bodyStyle[in]=#values#'
      },
      quoteIdQuote: {
        value: '',
        dataType: 'String',
        query: 'quote.idQuote[like]=#value#'
      },
      quoteTimeLimit: {
        value: [],
        dataType: 'Array',
        query: 'quote.timeLimit[in]=#values#'
      },
      carCO2Emission: {
        value: [],
        dataType: 'Range',
        query: 'car.cO2Emission[gte]=#value1#&car.cO2Emission[lte]=#value2#'
      },
      quoteYearKms: {
        value: [],
        dataType: 'Array',
        query: 'quote.yearKms[in]=#values#'
      },
      quotePrice: {
        value: [],
        dataType: 'Range',
        query: 'quote.price[gte]=#value1#&quote.price[lte]=#value2#'
      },
      deliveryProvinceCode: {
        value: [],
        dataType: 'Array',
        query: 'deliveryProvinceCode[in]=#values#'
      },
      campaignFactory: {
        value: '',
        dataType: 'String',
        query: 'campaignFactory[eqs]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  operationsListB2C: {
    filtersHasChanged: false,
    filters: {
      carPlateNumberB2C: {
        value: '',
        dataType: 'String',
        query: 'platenumber[eqs]=#value#'
      },
      idOperationB2C: {
        value: '',
        dataType: 'String',
        query: 'operationId[eqs]=#value#'
      },
      idOfferMotherB2C: {
        value: '',
        dataType: 'String',
        query: 'ofertId[eqs]=#value#'
      },
      phoneB2C: {
        value: '',
        dataType: 'String',
        query: 'phone[eqs]=#value#'
      },
      dniB2C: {
        value: '',
        dataType: 'String',
        query: 'dni[eqs]=#value#'
      },
      clienteNameB2C: {
        value: '',
        dataType: 'String',
        query: 'clientname[like]=#value#'
      },
      referenceB2C: {
        value: '',
        dataType: 'String',
        query: 'pedido[like]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  operationsListB2B: {
    filtersHasChanged: false,
    filters: {
      carPlateNumberB2B: {
        value: '',
        dataType: 'String',
        query: 'platenumber[eqs]=#value#'
      },
      idOperationB2B: {
        value: '',
        dataType: 'String',
        query: 'operationId[eqs]=#value#'
      },
      idOfferMotherB2B: {
        value: '',
        dataType: 'String',
        query: 'ofertId[eqs]=#value#'
      },
      phoneB2B: {
        value: '',
        dataType: 'String',
        query: 'phone[eqs]=#value#'
      },
      dniB2B: {
        value: '',
        dataType: 'String',
        query: 'dni[eqs]=#value#'
      },
      clienteNameB2B: {
        value: '',
        dataType: 'String',
        query: 'clientname[like]=#value#'
      },
      referenceB2B: {
        value: '',
        dataType: 'String',
        query: 'pedido[like]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  campaigns: {
    filtersHasChanged: false,
    filtersHasReseted: true,
    filters: {
      carBrand: {
        value: '',
        dataType: 'String',
        query: 'car.brand[eqs]=#value#'
      },
      carModel: {
        value: '',
        dataType: 'String',
        query: 'car.model[eqs]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },

  imagesBenchFilter: {
    filtersHasChanged: false,
    filters: {
      vehicleId: '',
      vehicleType: '',
      vehicleLocation: '',
      vehicleBrand: '',
      vehicleModel: '',
      vehicleVersion: '',
      vehicle: '',
      selectIdVehicle: ''
    }
  }
};

/** FILTROS ---------------------------- */

export const TYPE_VEHICLE_DESCRIPTION = {
  ALL: 'TODOS',
  USED: 'USADO',
  NEW: 'NUEVO',
  SALE: 'VENTA'
};

export const VEHICLE_CAMPAIGN_TYPE = {
  NEW: 'NUEVO',
  ALL: 'TODOS',
  USED: 'USADO',
  SALE: 'VENTA',
  RENTING: 'ALQUILER',
  RENTINGSALE: 'ALQUILER+VENTA'
};

export const PROVINCES = {
  '01': 'Ýlava ',
  '02': 'Albacete ',
  '03': 'Alicante ',
  '04': 'Almería ',
  '06': 'Badajoz ',
  '07': 'Baleares ',
  '08': 'Barcelona ',
  '09': 'Burgos ',
  10: 'Cáceres ',
  11: 'Cádiz ',
  12: 'Castellón ',
  13: 'Ciudad Real ',
  14: 'Córdoba ',
  15: 'La Coruña ',
  16: 'Cuenca',
  17: 'Girona ',
  18: 'Granada ',
  19: 'Guadalajara ',
  20: 'Guipuzcoa ',
  21: 'Huelva ',
  22: 'Huesca ',
  23: 'Jaén ',
  24: 'León ',
  25: 'Lleida ',
  26: 'La Rioja ',
  27: 'Lugo',
  28: 'Madrid ',
  29: 'Málaga ',
  30: 'Murcia ',
  31: 'Navarra ',
  32: 'Orense ',
  33: 'Asturias ',
  34: 'Palencia ',
  35: 'Las Palmas de G.C. ',
  36: 'Pontevedra ',
  37: 'Salamanca ',
  38: 'Tenerife ',
  39: 'Cantabria ',
  40: 'Segovia ',
  41: 'Sevilla ',
  42: 'Soria ',
  43: 'Tarragona ',
  44: 'Teruel ',
  45: 'Toledo ',
  46: 'Valencia',
  47: 'Valladolid ',
  48: 'Vizcaya ',
  49: 'Zamora ',
  50: 'Zaragoza ',
  51: 'Ceuta ',
  52: 'Melilla '
};

export const ACTION_TYPE_CAMPAIGN = {
  DETAIL: 'detail',
  CLONE: 'clone',
  EDIT: 'edit',
  ADVANCED_EDIT: 'advanced-edit',
  MULTIPLE: 'multiple'
};

export const MAX_TOP_CAMPAIGNS = 50;

export const MARKETPLACE = {
  AMAZON: 'Amazon',
  UK: 'UK Digital'
};
export const MARKETPLACE_STATE = {
  PUBLICATION: 'Publicada'
};

export const STOCK = {
  NOT_AVAILABLE: 'No hay stock'
};

export const CAMPAIGNS_VISIBILTY_VALUES = [
  {
    key: 'active',
    value: i18n.t('ui.select.active')
  },
  {
    key: 'noActive',
    value: i18n.t('ui.select.noActive')
  }
];

export const SERVICES_OPTIONS = [
  {
    value: 'Incluido',
    label: i18n.t('ui.label.included')
  },
  {
    value: 'No Incluido',
    label: i18n.t('ui.label.notIncluded')
  },
  {
    value: 'No Incorporado',
    label: i18n.t('ui.label.notIncorporated')
  }
];

export const SECTION_MENU_ITEMS_ACTIONS = {
  generic: {
    'operations-list-b2c': ['reload', 'exportToExcel'],
    'operations-list-b2b': ['reload', 'exportToExcel'],
    'operations-expiration': ['exportToExcel'],
    'garage-campaigns': ['reload', 'exportToExcel'],
    showroom: ['reload'],
    'garage-campaign': [],
    'garage-new-campaign': [],
    cms: []
  },
  sections: {
    'operations-list-b2c': ['operations'],
    'operations-list-b2b': ['operations'],
    'garage-campaigns': ['campaigns'],
    'garage-campaign': ['campaigns'],
    'edit-multiple-campaigns': ['campaigns'],
    'garage-new-campaign': ['campaigns'],
    cms: ['cms']
  },
  subSections: {
    'garage-campaign': ['editCampaign', 'detailCampaign', 'advancedEditCampaign'],
    'edit-multiple-campaigns': ['editCampaign']
  }
};

export const CHECK_SMS_SERVICE = 'checkSms';
export const CHECK_SMS_MESSAGE = 'ValidateCheckSms';

export const VEHICLE_INFORMATION_OBJECT = {
  vehicleId: '',
  shellType: '',
  location: '',
  brand: '',
  model: '',
  version: '',
  vehiculo: ''
};

/** STATUS LIST PUBLICATIONS MASIVE  */
export const MASIVE_PUBLICATION_STATUS = {
  C: i18n.t('ui.label.masivePublicationStatusCreated'),
  R: i18n.t('ui.label.masivePublicationStatusReady'),
  P: i18n.t('ui.label.masivePublicationStatusPublished'),
  E: i18n.t('ui.label.masivePublicationOfferStatusError'),
  I: i18n.t('ui.label.masivePublicationOfferStatusInvalid'),
  F: i18n.t('ui.label.masivePublicationStatusFail'),
  I1: i18n.t('ui.label.masivePublicationOfferStatusInvalid1'),
  I2: i18n.t('ui.label.masivePublicationOfferStatusInvalid2'),
  I3: i18n.t('ui.label.masivePublicationOfferStatusInvalid3'),
  I4: i18n.t('ui.label.masivePublicationOfferStatusInvalid4'),
  I5: i18n.t('ui.label.masivePublicationOfferStatusInvalid5'),
  I6: i18n.t('ui.label.masivePublicationOfferStatusInvalid6'),
  PP: i18n.t('ui.label.masivePublicationOfferStatusPartiallyPublished')
};

/** STATUS LIST OFFERS MASIVE  */
export const MASIVE_PUBLICATION_OFFER_STATUS = {
  C: i18n.t('ui.label.masivePublicationOfferStatusCreated'),
  R: i18n.t('ui.label.masivePublicationOfferStatusReady'),
  P: i18n.t('ui.label.masivePublicationOfferStatusPublished'),
  E: i18n.t('ui.label.masivePublicationOfferStatusError'),
  I: i18n.t('ui.label.masivePublicationOfferStatusInvalid'),
  I1: i18n.t('ui.label.masivePublicationOfferStatusInvalid1'),
  I2: i18n.t('ui.label.masivePublicationOfferStatusInvalid2'),
  I3: i18n.t('ui.label.masivePublicationOfferStatusInvalid3'),
  I4: i18n.t('ui.label.masivePublicationOfferStatusInvalid4'),
  I5: i18n.t('ui.label.masivePublicationOfferStatusInvalid5'),
  I6: i18n.t('ui.label.masivePublicationOfferStatusInvalid6'),
  PP: i18n.t('ui.label.masivePublicationOfferStatusPartiallyPublished')
};

export const MASIVE_PUBLICATION_OFFER_STATUS_INVALID = [
  'I',
  'I1',
  'I2',
  'I3',
  'I4',
  'I4',
  'I5',
  'I6',
  'E',
  'P'
];

export const MASIVE_STATUS = {
  PUBLISHED: 'P'
};

export const MAIN_NOTIFICATION = {
  active: false,
  variant: 'success', // success, danger
  time: 5, // Segundos
  message: ''
};
